import React from 'react';
import './index.scss';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

const ErrorContent = ({ message, width, height, onButtonClick }) => {

    const style = {
        width: width || '100%',
        height: height || '100%'
    };

    const header = (
        <img alt="Card" src="https://primefaces.org/cdn/primereact/images/usercard.png" />
    );
    const footer = (
        <>
            <Button label="Tekrar Yükle" severity="secondary"
                icon="pi pi-refresh"
                style={{ background: "white", border: "none", color: "#ff5757", borderRadius: 25, fontSize: 19 }} raised onClick={onButtonClick} />
        </>
    );

    const cardStyle = {
        width: width || '100%',
        height: height || '100%',
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
        "text-align": "center",
        "backdrop-filter": "blur(10px)",
        "background": "rgba(255, 231, 230, 0.7)",
        "border": "solid #ff5757",
        "color": "#ff5757",
        "box-shadow": "0 3px 12px 0 rgba(255, 231, 230, 0.9)",
        "border-width": "4px 0 0 0px"
    }

    return (
        <div className="error-container" style={style}>

            <div className="card w-full flex justify-content-center align-items-center border-0 ">
                <Card title={message || 'Bir hata oluştu'} subTitle="" footer={footer} className="w-full" style={cardStyle}>
                    <p className="m-0"></p>
                </Card>
            </div>
        </div>
    );
};

export default ErrorContent;
